import type React from "react";
import { AppConfig } from "~/config";

interface PaymentGatewayRendererProps {
	pagarmeComponent: React.ReactNode;
	kiwifyComponent: React.ReactNode;
}

export function PaymentGatewayRenderer({
	pagarmeComponent,
	kiwifyComponent,
}: PaymentGatewayRendererProps) {
	// Determine active provider from config instead of env
	const activeProvider = AppConfig.ACTIVE_PAYMENT_PROVIDER;

	if (activeProvider === "kiwify") {
		return <>{kiwifyComponent}</>;
	}

	// Default fallback to pagarme
	return <>{pagarmeComponent}</>;
}
